import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Paper } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { Card, CollapseCard, Typography } from '@totalsoft/rocket-ui';
import InsuranceFlowCascoChecksHeader from './InsuranceFlowCascoChecksHeader';
import { emptyString } from 'constants/defaultValues';
import { CascoConventionName, CascoConventionWrapper } from '../FlowCheckStyles';

const InsuranceFlowCascoCheckComponent = ({
  cascoQuotations,
  verificationStatus,
  configurationJSON,
  insurersData,
  periods,
  openDialog,
  onOpenDialog,
  onCloseDialog,
  onCancelDialog,
  onChangeJsonValue,
  onCheckCascoQuotations,
  onReloadJson
}) => {
  const { t } = useTranslation();

  return (
    <CollapseCard
      title={t('Settings.InsuranceIntegrationChecks.CascoCheck.ObtainingQuotations')}
      icon={PlaylistAddCheckIcon}
      defaultExpanded={true}
      toggleOnHeaderClick
    >
      <Grid item container xs={12}>
        <InsuranceFlowCascoChecksHeader
          verificationStatus={verificationStatus}
          configurationJSON={configurationJSON}
          insurersData={insurersData}
          periods={periods}
          openDialog={openDialog}
          onOpenDialog={onOpenDialog}
          onCloseDialog={onCloseDialog}
          onCancelDialog={onCancelDialog}
          onChangeJsonValue={onChangeJsonValue}
          onCheckCascoQuotations={onCheckCascoQuotations}
          onReloadJson={onReloadJson}
        />
        <Grid item container xs={12} direction='row' alignItems='center' spacing={2} my={0}>
          {cascoQuotations && cascoQuotations != null && cascoQuotations.length > 0
            ? cascoQuotations.map((quotation, index) => (
                <Grid item container xs={12} lg={6} xl={4} key={index}>
                  <Card>
                    <CascoConventionWrapper item container>
                      <Grid item container xs={12} justifyContent={'space-between'} alignItems={'center'} wrap={'nowrap'} mb={1}>
                        <CascoConventionName title={quotation.conventionName}>{quotation.conventionName}</CascoConventionName>
                      </Grid>
                      <Grid item container xs={6} alignItems={'flex-end'} wrap={'nowrap'}>
                        <Grid item xs={12}>
                          <strong> {t('Offer.Edit.Casco.Header.InsurerName')}:</strong>
                          <span>{quotation.insurerName || 'N/A'}</span>
                        </Grid>
                      </Grid>
                      <Grid item container xs={6} alignItems={'flex-end'} wrap={'nowrap'}>
                        <Grid item xs={12}>
                          <strong>{t('Offer.Edit.Casco.Header.PeriodMonth')}:</strong>
                          <span>{quotation.period || 'N/A'}</span>
                        </Grid>
                      </Grid>
                      <Grid item container xs={6} alignItems={'flex-end'} wrap={'nowrap'}>
                        <Grid item xs={12}>
                          <strong>{t('Offer.Edit.Casco.Header.InsuranceAmount')}:</strong>
                          <span>
                            {' '}
                            {quotation.insuranceAmount
                              ? `${t('DECIMAL2', {
                                  number: quotation.insuranceAmount || emptyString
                                })} ${quotation.currencyCode}`
                              : 'N/A'}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid item container xs={6} alignItems={'flex-end'} wrap={'nowrap'}>
                        <Grid item xs={12}>
                          <strong>{t('Offer.Edit.Casco.Header.TotalInsuranceAmount')}:</strong>
                          <span>
                            {quotation.totalInsuranceAmount
                              ? `${t('DECIMAL2', {
                                  number: quotation.totalInsuranceAmount || emptyString
                                })} ${quotation.currencyCode}`
                              : 'N/A'}
                          </span>
                        </Grid>
                      </Grid>
                    </CascoConventionWrapper>
                  </Card>
                </Grid>
              ))
            : verificationStatus.loading === false &&
              verificationStatus.message && (
                <Grid container xs={12}>
                  <Paper>
                    <Typography variant='subtitle2' align='center'>
                      {verificationStatus.message}
                    </Typography>
                  </Paper>
                </Grid>
              )}
        </Grid>
      </Grid>
    </CollapseCard>
  );
};

InsuranceFlowCascoCheckComponent.propTypes = {
  cascoQuotations: PropTypes.array,
  verificationStatus: PropTypes.object,
  configurationJSON: PropTypes.object,
  insurersData: PropTypes.object,
  periods: PropTypes.object,
  openDialog: PropTypes.bool,
  onOpenDialog: PropTypes.func,
  onCloseDialog: PropTypes.func,
  onCancelDialog: PropTypes.func,
  onChangeJsonValue: PropTypes.func,
  onCheckCascoQuotations: PropTypes.func,
  onReloadJson: PropTypes.func
};

export default InsuranceFlowCascoCheckComponent;
